import React from 'react';

/* helper – resolves to /public/assets/images/<path> */
const img = (file) => `${process.env.PUBLIC_URL}/assets/images/${file}`;

export default function Industry() {
  /* the eight cards exactly as in the template */
  const sectors = [
    ['Automobile',        'CAD Services, DTP Services',                       'team-member/automobile-img.png'],
    ['Telecom Industry',  'Translation Service, Voiceover & Subtitling',      'team-member/telecom-img.png'],
    ['Legal',             'Translation Service, Content Writing',             'team-member/legal-img.png'],
    ['E-commerce & Retail','Website Localization, Content Writing',           'team-member/e-commerce-img.png'],
    ['Travel',            'Translation Service, Voiceover & Subtitling',      'team-member/travel-img.png'],
    ['E-learning',        'Voiceover & Subtitling, Software Localization',    'team-member/e-learning-img.png'],
    ['Finance & Banking', 'Translation Service, Content Writing',             'team-member/finance-img.png'],
    ['Medical',           'Translation Service, DTP Services',                'team-member/medical-img.png'],
  ];

  return (
    <div className="page">
      {/* ──────────  PAGE TITLE STRIPE  ────────── */}
      <div className="ttm-page-title-row">
        <div className="ttm-page-title-row-inner">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-12">
                <div className="page-title-heading ttm-textcolor-white">
                  <h2 className="title">Industry</h2>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ──────────  SITE-MAIN  ────────── */}
      <div className="site-main">

        {/* =======  INDUSTRY GRID  ======= */}
        <section className="ttm-row grid-section clearfix">
          <div className="container">

            {/* split into two rows of four, keeping the same markup */}
            <div className="row">
              {sectors.slice(0, 4).map(([title, desc, pic]) => (
                <div key={title} className="col-lg-3 col-md-6 col-sm-6">
                  <div className="featured-imagebox featured-imagebox-team style2">
                    <div className="ttm-box-view-overlay">
                      <div className="featured-thumbnail">
                        <img className="img-fluid" src={img(pic)} alt={title} />
                      </div>
                    </div>
                    <div className="featured-content text-center">
                      <div className="featured-title"><h5>{title}</h5></div>
                      <p className="team-position">{desc}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className="row mt-4">
              {sectors.slice(4).map(([title, desc, pic]) => (
                <div key={title} className="col-lg-3 col-md-6 col-sm-6">
                  <div className="featured-imagebox featured-imagebox-team style2">
                    <div className="ttm-box-view-overlay">
                      <div className="featured-thumbnail">
                        <img className="img-fluid" src={img(pic)} alt={title} />
                      </div>
                    </div>
                    <div className="featured-content text-center">
                      <div className="featured-title"><h5>{title}</h5></div>
                      <p className="team-position">{desc}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>

          </div>
        </section>
      </div>{/* site-main */}
    </div>
  );
}